import type { IGetAllLeagues } from '../components/header/types/header';
import type { IGetAllTournaments } from '../views/leaguesHome/types/home';
import type { ITeamSnapshotResponse } from '../views/myTeam/types/myTeam';
import { canManageLeagueGalleryByRole } from './leagueAccess';

/** League tab gallery: user must be able to edit league settings. */
export function canManageLeagueGallery(league: IGetAllLeagues | null | undefined): boolean {
  return canManageLeagueGalleryByRole(league);
}

/** Tournament gallery: user must have tournament edit rights for this tournament. */
export function canManageTournamentGallery(
  tournament: IGetAllTournaments | null | undefined,
): boolean {
  return Boolean(tournament?.canEditTournament);
}

/** Team photos: user must have team edit rights on this snapshot (from teamsSnapShotByTeamId). */
export function canManageTeamGalleryFromSnapshot(
  snapshots: ITeamSnapshotResponse[] | undefined,
  teamSnapshotId: string | null | undefined,
): boolean {
  if (!teamSnapshotId?.trim()) return false;
  const row = snapshots?.find((s) => s.teamSnapshotId === teamSnapshotId);
  return Boolean(row?.canEditTeam);
}

export function findTournamentById(
  list: IGetAllTournaments[] | undefined,
  tournamentId: string | null | undefined,
): IGetAllTournaments | null {
  if (!tournamentId?.trim() || !list?.length) return null;
  return list.find((t) => t.tournamentId === tournamentId) ?? null;
}
